import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-logs",
  "use": "icon-logs-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 64 64\" id=\"icon-logs\">\r\n<path d=\"M47.4,29.3c2.2,0,4.4,0.4,6.4,1.1V4.5c0-2.4-2-4.4-4.4-4.4H5.9c-2.4,0-4.4,2-4.4,4.4v52.1c0,2.4,2,4.4,4.4,4.4h26.3\r\n\tc-2.7-3.3-4.3-7.6-4.3-12.2C27.9,38,36.6,29.3,47.4,29.3z M8.8,14.5c0-1.6,1.3-2.8,2.8-2.8h31.6c1.6,0,2.8,1.3,2.8,2.8\r\n\tc0,1.6-1.3,2.8-2.8,2.8H11.6C10,17.4,8.8,16.1,8.8,14.5z M8.8,28.4c0-1.6,1.3-2.8,2.8-2.8H30c1.6,0,2.8,1.3,2.8,2.8\r\n\tc0,1.6-1.3,2.8-2.8,2.8H11.6C10,31.2,8.8,29.9,8.8,28.4z M25.7,42.2c0,1.6-1.3,2.8-2.8,2.8H11.6c-1.6,0-2.8-1.3-2.8-2.8\r\n\tc0-1.6,1.3-2.8,2.8-2.8h11.3C24.4,39.4,25.7,40.6,25.7,42.2z\" />\r\n<path d=\"M47.4,33.7c-8.3,0-15.1,6.8-15.1,15.1s6.8,15.1,15.1,15.1s15.1-6.8,15.1-15.1S55.7,33.7,47.4,33.7z M56.7,50.1\r\n\tc0,0.9-0.8,1.7-1.7,1.7h-8.1c-0.9,0-1.7-0.8-1.7-1.7V39.1c0-0.9,0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7v9.3H55\r\n\tC55.9,48.4,56.7,49.2,56.7,50.1z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/logs.svg
// module id = 49QO
// module chunks = 123